import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	getRotationErrorTitle: {
		id: 'eoc-schedule.controllers.edit.get-rotation-error-title',
		defaultMessage: "We couldn't get your rotation.",
		description:
			'This message indicates that our back-end services did not respond when getting rotation.',
	},
	deleteRotationErrorTitle: {
		id: 'eoc-schedule.controllers.edit.delete-rotation-error-title',
		defaultMessage: 'We could not delete the rotation.',
		description:
			'This message indicates that our back-end services did not respond when deleting rotation.',
	},
	addRotationErrorTitle: {
		id: 'eoc-schedule.controllers.edit.add-rotation-error-title',
		defaultMessage: 'We could not add the rotation.',
		description:
			'This message indicates that our back-end services did not respond when adding rotation.',
	},
	editRotationErrorTitle: {
		id: 'eoc-schedule.controllers.edit.edit-rotation-error-title',
		defaultMessage: 'We could not edit the rotation.',
		description:
			'This message indicates that our back-end services did not respond when editting rotation.',
	},
	orderRotationErrorTitle: {
		id: 'eoc-schedule.controllers.edit.order-rotation-error-title',
		defaultMessage: 'We could not order the rotation at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when ordering rotations.',
	},
	forEveryday: {
		id: 'eoc-schedule.controllers.edit.for-everyday',
		defaultMessage: 'For everyday',
		description: 'Label of timing type radio button: For repeating time intervals for everyday.',
	},
	customizeDays: {
		id: 'eoc-schedule.controllers.edit.customize-days',
		defaultMessage: 'Customize days',
		description:
			'Label of timing type radio button: For allowing to add custom date-time intervals.',
	},
	hours: {
		id: 'eoc-schedule.controllers.edit.custom.hours',
		defaultMessage: 'Hours',
		description: 'Text that indicates hours repeation',
	},
	days: {
		id: 'eoc-schedule.controllers.edit.custom.days',
		defaultMessage: 'Days',
		description: 'Text that indicates days repeation',
	},
	weeks: {
		id: 'eoc-schedule.controllers.edit.custom.weeks',
		defaultMessage: 'Weeks',
		description: 'Text that indicates weeks repeation',
	},
	daily: {
		id: 'eoc-schedule.controllers.edit.daily',
		defaultMessage: 'Daily',
		description: 'Text that indicates daily repeation',
	},
	weekly: {
		id: 'eoc-schedule.controllers.edit.weekly',
		defaultMessage: 'Weekly',
		description: 'Text that indicates weekly repeation',
	},
	custom: {
		id: 'eoc-schedule.controllers.edit.custom',
		defaultMessage: 'Custom',
		description: 'Text that indicates custom repeation',
	},
	addRotationSuccessTitle: {
		id: 'eoc-schedule.controllers.edit.add-rotation-success-title',
		defaultMessage: "You've added new rotation.",
		description: 'Success message for adding rotation.',
	},
	editRotationSuccessTitle: {
		id: 'eoc-schedule.controllers.edit.edit-rotation-success-title',
		defaultMessage: "You've updated the rotation.",
		description: 'Success message for editing rotation.',
	},
});
